import React from "react";
import { Box, CircularProgress } from "@mui/material";
import RegisterPageScaffold from "../SHARED/RegisterPageScaffold";
import { getRegisterVariant } from "../SHARED/registerPageConfig";
import RegisterStandardFormBody from "../SHARED/components/RegisterStandardFormBody";
import RegisterPageDialogs, { RegisterPageBottomBar } from "../SHARED/components/RegisterPageDialogs";
import { usePgContactRegister } from "../SHARED/hooks/usePgContactRegister";

const VARIANT_ID = "pgContact";

const PgContactRegister = () => {
  const pg = usePgContactRegister();
  const cfg = getRegisterVariant(VARIANT_ID);

  if (pg.loadingProfile) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
        data-testid="register-loading"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <RegisterPageScaffold
      config={cfg}
      minHeight={cfg.minHeight}
      bottomBar={<RegisterPageBottomBar reg={pg} />}
      dialogs={<RegisterPageDialogs reg={pg} />}
    >
      <RegisterStandardFormBody reg={pg} showPgPhoneMask={pg.showPgPhoneMask} />
    </RegisterPageScaffold>
  );
};

export default PgContactRegister;
